<template>
  <article>
    <div class="article-image">
      <img v-if="file.picture" :src="`/api/v1/companies/1/images/${file.picture.id}/view?width=640`"
           :alt="file.title" />
    </div>

    <div class="article-content">
      <div class="article-info">
        <h2>{{ file.title }}</h2>

        <p>{{ file.description }}</p>

        <div class="article-categories">
          <a-tag
              v-for="category in file.categories" :key="category.id">
            {{ category.name }}
          </a-tag>
        </div>
      </div>

      <div class="article-buttons">
        <a :href="`/api/v1/companies/1/documents/files/${file.id}/download?token=${getJwt()}`">
          <a-button type="primary">
            Letöltés
          </a-button>
        </a>
      </div>
    </div>
  </article>
</template>

<script>
import axios from "axios";
import moment from "moment";
import LocalStorage from '@/helpers/localstorage';

export default {
  props: {
    file: Object,
  },
  methods: {
    getJwt() {
      return LocalStorage.getJwt()
    }
  }
}
</script>

<style lang="scss" scoped>
article {
  margin: 12px 0;
  background: #FFF;
  border: 1px solid #EFEFEF;
  display: flex;
  flex-flow: column;
  gap: 4px;
}

article .article-content {
  padding: 8px;
  display: flex;
  flex-flow: column nowrap;
  flex: 1;
  width: 100%;
}

article .article-info {
  flex: 1;
}

article .article-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 4px;
}

article .article-categories {
  margin-bottom: 8px;
  color: #222;
}

article .article-image {
  overflow: hidden;
  position: relative;
  width: 100%;
  aspect-ratio: 16/9;
}

article .article-image img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
</style>